export default __webpack_public_path__ + "static/media/13.be4cf2e9.jpg";